import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const FeedbackContainer = styled(Box)({
  width: 'fit-content',
  position: 'absolute',
  bottom: 12,
  right: 12,

  display: 'flex',
  padding: 'px 12px',
  flexDirection: 'column',
  alignitems: 'flex-start',
  gap: 4
});

export const FeedbackButton = styled(SButton)({
  width: 125,
  height: 38,
  maxHeight: 38,
  minHeight: 38,
  color: '#F8F9FA',
  textAlign: 'center',
  fontSize: 12,
  fontStyle: 'normal',
  fontWeight: 600,
  letterSpacing: 0,
  borderRadius: 120,
  background: '#20262D',

  '&:hover': {
    background: '#EEF0F2',
    color: '#20262D',
    borderRadius: 120
  }
});
